export function convertColumnWidthMapToStoredWidths(columnWidthsMap: Map<string, number>): string {
  try {
    return JSON.stringify(Object.fromEntries(columnWidthsMap))
  } catch (e) {
    return JSON.stringify({})
  }
}
